import { useNavigate } from "react-router-dom";
//Redux
import { useDispatch, useSelector } from "react-redux";
import { setComponentActive, setFloatPanelData, updateFloatPanelVisibility } from "../../reducers/userConfigSlice";

import { MdKeyboardArrowRight } from "react-icons/md";
import "./style.css";
import { NoImage } from "@delibrandev/utils";
import { FloatPanel } from "../floatPanel";
import { FloatComponent } from "../../pages/products/floatComponent";

export const ItemList = ({ data, onClick }) => {
  return (
    <div
      className="itemList"
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick?.(e);
        }
      }}
    >
      <div className="itemListImage" style={{ backgroundImage: data?.images?.[0] ? `url('${data.images[0]}')` : "none" }}>
        {!data.images?.[0] && <NoImage />}
      </div>
      <div className="itemListName">{data.name}</div>
    </div>
  );
};

export const RowItemList = ({ data, haveWrap = true }) => {
  console.log("RowItemList");
  const floatPanel = useSelector((state) => state.aplicationConfig.userConfig.floatPanel);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleViewAll = () => {
    const basePath = data.name === "Productos" ? "/products" : "/categories";
    dispatch(setComponentActive(basePath));
    navigate(basePath);
  };

  const handleCategoryClick = (categoryName) => {
    const formattedCategory = encodeURIComponent(categoryName.toLowerCase());
    dispatch(setComponentActive(`products/${formattedCategory}`));
    navigate(`/products/${formattedCategory}`);
  };

  const handleFloatPanelVisibility = (data = null) => {
    dispatch(updateFloatPanelVisibility());
    dispatch(setFloatPanelData(data));
  };

  return (
    <>
      <div className="rowItemList">
        <div className="rowItemListHeader">
          <div>
            <h2>{data.name}</h2>
          </div>
          {haveWrap && (
            <div
              className="actionLabel"
              role="button"
              tabIndex={0}
              onClick={handleViewAll}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  handleViewAll();
                }
              }}
            >
              Ver todos <MdKeyboardArrowRight />
            </div>
          )}
        </div>
        <div className={haveWrap ? "rowItemListBody" : "rowItemListBodyWrap"}>
          {data.name === "Productos"
            ? data.list.map((product) => <ItemList key={product.productId} data={product} onClick={() => handleFloatPanelVisibility(product)} />)
            : data.list
                ?.filter((category) => Array.isArray(category.Products) && category.Products.length > 0)
                .map((category) => <ItemList key={category.categoryId} data={category} onClick={() => handleCategoryClick(category.name)} />)}
        </div>
      </div>
      {floatPanel.visible && <FloatPanel component={<FloatComponent data={floatPanel.data} />} />}
    </>
  );
};
